import { render, staticRenderFns } from "./LotViewButton.vue?vue&type=template&id=6c9bfde7&scoped=true&"
import script from "./LotViewButton.vue?vue&type=script&lang=js&"
export * from "./LotViewButton.vue?vue&type=script&lang=js&"
import style0 from "./LotViewButton.vue?vue&type=style&index=0&id=6c9bfde7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9bfde7",
  null
  
)

export default component.exports